@if (features.kiosk.enabled) {
<era-device-grid-ui [devices]="kioskDevices$ | async"
                    (selected)="itemSelected($event)">
  <div class="title d-flex align-items-center">
    <h6>Kiosk ({{ kioskDevicesCount$ | async }})</h6>
    @if (features.devices.reboot) {
    <div class="ms-auto flex-shrink-1 d-flex align-items-center mb-1">
      <era-context-menu>
        <button ngbDropdownItem
                (click)="openRebootRequest()">Setup reboot</button>
      </era-context-menu>
    </div>
    }
  </div>
  <div class="empty">
    <p>No kiosk devices.</p>
  </div>
</era-device-grid-ui>
}